import { render, staticRenderFns } from "./BaseAtendimento.vue?vue&type=template&id=1a389f12&scoped=true&"
import script from "./BaseAtendimento.vue?vue&type=script&lang=js&"
export * from "./BaseAtendimento.vue?vue&type=script&lang=js&"
import style0 from "./BaseAtendimento.vue?vue&type=style&index=0&id=1a389f12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a389f12",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRangeSlider } from 'vuetify/lib/components/VRangeSlider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRangeSlider,VRow})
